const newsIcons = {
  global:  'nc-icon x2 nc-world-2',
  team:  'fa fa-2x fa-users'
}

export {
  newsIcons
}